import React from 'react';
import { Link } from 'react-router-dom';

// Site-wide footer. Rendered once in App.js at the bottom of the page-content
// container so it appears on every route.
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer style={{
      borderTop: '1px solid var(--border)',
      background: 'var(--card)',
      padding: '22px 20px',
      marginTop: 'auto',
    }}>
      <div style={{
        maxWidth: 1100, margin: '0 auto',
        display: 'flex', flexWrap: 'wrap', gap: 16,
        alignItems: 'center', justifyContent: 'space-between',
      }}>
        <nav style={{ display: 'flex', flexWrap: 'wrap', gap: 18 }}>
          <FooterLink to="/about">About Us</FooterLink>
          <FooterLink to="/api-access">API</FooterLink>
          <FooterLink to="/contact">Contact Us</FooterLink>
          <FooterLink to="/terms">Terms &amp; Conditions</FooterLink>
          <FooterLink to="/privacy">Privacy Policy</FooterLink>
        </nav>
        <div style={{ color: 'var(--muted)', fontSize: 12 }}>
          &copy; {year} Algovex LLC. All rights reserved.
        </div>
      </div>
      <div style={{
        maxWidth: 1100, margin: '10px auto 0', color: 'var(--muted)',
        fontSize: 11, lineHeight: 1.5, opacity: 0.8,
      }}>
        Algovex is a research and educational tool. Nothing on this site is financial advice, and
        past or simulated performance does not guarantee future results.
      </div>
    </footer>
  );
}

function FooterLink({ to, children }) {
  return (
    <Link
      to={to}
      style={{ color: 'var(--muted)', fontSize: 13, textDecoration: 'none' }}
      onMouseEnter={(e) => { e.currentTarget.style.color = 'var(--teal)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.color = 'var(--muted)'; }}
    >
      {children}
    </Link>
  );
}
